module.exports = __webpack_public_path__ + "static/media/todo.b288b3cd.png";